import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  SimpleGrid,
  Flex,
} from "@chakra-ui/react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const CreateAcademicYear = () => {
  const [formData, setFormData] = useState({
    user_id: sessionStorage.getItem("user_id"),
    school_id: sessionStorage.getItem("school_id"),
    year_name: "",
    start_date: "",
    end_date: "",
    status: "active",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await axios.post(
        `${BASE_URL}/admin/academic_year/create_year.php`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("Response", response);

      console.log("formdata", formData);

      setMessage(response.data.message);
      // Reset the form after successful submission
      setFormData({
        user_id: sessionStorage.getItem("user_id"),
        school_id: sessionStorage.getItem("school_id"),
        year_name: "",
        start_date: "",
        end_date: "",
        status: "active",
      });
    } catch (error) {
      setMessage(
        error.response?.data?.message || "Failed to create academic year"
      );
    }
  };

  return (
    <Box
      p={6}
      maxW="100%"
      mx="auto"
      boxShadow="md"
      borderRadius="md"
      bg="white"
    >
      {message && (
        <Text color={message.includes("Failed") ? "red.500" : "green.500"}>
          {message}
        </Text>
      )}
      <form onSubmit={handleSubmit}>
        <SimpleGrid columns={2} spacing={4}>
          <FormControl isRequired>
            <FormLabel>Year Name</FormLabel>
            <Input
              type="text"
              name="year_name"
              value={formData.year_name}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Start Date</FormLabel>
            <Input
              type="date"
              name="start_date"
              value={formData.start_date}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>End Date</FormLabel>
            <Input
              type="date"
              name="end_date"
              value={formData.end_date}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Status</FormLabel>
            <Select
              mt={5}
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Select>
          </FormControl>
        </SimpleGrid>
        <Flex justifyContent="flex-end" mt={4}>
          <Button type="submit" colorScheme="blue">
            Create
          </Button>
        </Flex>
      </form>
    </Box>
  );
};

export default CreateAcademicYear;
